<script>
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header'
import { GET_VEHICLES_PAGINATED, UPDATE_VEHICLES } from '@/services/api/master/fleet'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'

export default {
  components: {
    McGrapqlTable,
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
  },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      form: {
        idleTimeLimit: 15,
        parkingTimeLimit: 1440,
      },
      idChecked: [],
      isUpdated: false,
      tableKey: 1,
    }
  },
  computed: {
    idleTimeLimitState() {
      return this.form.idleTimeLimit >= 5 && this.form.idleTimeLimit <= 10080
    },
    parkingTimeLimitState() {
      return this.form.parkingTimeLimit >= 5 && this.form.parkingTimeLimit <= 10080
    },
    isValidModal() {
      return this.idleTimeLimitState && this.parkingTimeLimitState
    },
    title() {
      return this.$t('setting.list.trackerSensor.idleParking')
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
    }),
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.list.trackerSensor.trackerSensor'),
          to: { name: 'Setting Tracker & Sensor' },
        },
        {
          text: this.$t('setting.list.trackerSensor.idleParking'),
          active: true,
        },
      ]
    },
    /**
     * Management Field for b-table
     */
    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('setting.list.fleetGroup.form.licensePlate'),
          thClass: 'mc-table--150',
          isSortable: true,
          isEditable: false,
        },
        {
          key: 'idleTimeLimit',
          label: `${this.$t('setting.list.trackerSensor.idleTimeLimit')} (${this.$t(
            'global.time.minutes'
          )})`,
          thClass: 'mc-table--200',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'parkingTimeLimit',
          label: `${this.$t('setting.list.trackerSensor.parkingTimeLimit')} (${this.$t(
            'global.time.minutes'
          )})`,
          thClass: 'mc-table--200',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'imei',
          label: this.$t('setting.list.trackerSensor.imei'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetGroup',
          label: this.$t('setting.list.trackerSensor.fleetGroup'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetCategory',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetType',
          label: this.$t('setting.list.fleetSetting.fleetType'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          filter.status = ['I', 'R']
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_VEHICLES_PAGINATED,
            variables: {
              filter: filter,
            },
          })
          let result = res.data.vehiclesPaginated.vehiclesPaginated
          result.data.forEach((item, index) => {
            const vgroups = item.vehicle2Vgroup
            const nameGroups = vgroups.map((item) => item.vgroup.name)
            result.data[index].vgroups = nameGroups.join(', ')
          })
          return result
        },
      }
    },
  },
  methods: {
    openModal() {
      this.form = {
        idleTimeLimit: 15,
        parkingTimeLimit: 1440,
      }
      this.$bvModal.show('parameter-idle-parking')
    },

    applyParameter() {
      this.$bvModal.show('mc-modal-confirm')
    },

    async submitParameter() {
      this.isUpdated = true
      this.$bvModal.hide('parameter-idle-parking')
      this.$bvModal.hide('mc-modal-confirm')
      const newData = {
        idleDuration: Number(this.form.idleTimeLimit),
        parkingDuration: Number(this.form.parkingTimeLimit),
      }
      const id = []
      this.idChecked.forEach((item) => {
        id.push(Number(item))
      })
      const input = {
        id,
        newData,
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_VEHICLES,
        variables: {
          input: input,
        },
      })
      const message = res.data.updateVehicles.message
      this.isUpdated = false
      this.idChecked = []
      if (message == 'Successful') {
        this.tableKey += 1
        this.$mcToast.success(this.$t('global.alert.text.changed'))
      } else {
        this.$mcToast.error(this.$t('global.alert.text.failChange'))
      }
    },

    handleCheckbox(ids) {
      const resultKey = []
      const keys = Object.keys(ids)
      keys.forEach((item) => {
        if (ids[item]) resultKey.push(item)
      })
      this.idChecked = resultKey
    },

    onRowClicked(item) {
      if (!this.hasAccessAll(['set_idle_parking:read', 'set_idle_parking:update'])) {
        return
      }
      this.$router.push({
        name: 'Idle & Parking Limit Times Update',
        params: { vehicleId: item.id },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="mc-page-three" />
    <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
      <div class="float-end">
        <McButtonBack href="/setting/tracker-sensor/" />
      </div>
      <div class="item-right my-5 py-1">
        <div class="d-flex my-3">
          <McButton
            variant="secondary"
            class="mx-2"
            hidden
            :text="$t('report.object.filter')"
            icon="icon-outline_funnel"
          />
          <McButton
            v-if="hasAccess(['set_idle_parking:update'])"
            variant="secondary"
            class="mx-2"
            :disabled="isUpdated || idChecked.length <= 0"
            :text="$t('setting.list.trackerSensor.setParameter')"
            @click="openModal()"
          >
            <template #before-slot>
              <b-spinner v-if="isUpdated" small label="Small Spinner" />
            </template>
          </McButton>
        </div>
      </div>
    </div>

    <div class="py-5">
      <!-- Table -->
      <div class="datatables table-responsive my-3">
        <McGrapqlTable
          :key="tableKey"
          :apiClient="query"
          :fields="fields"
          :hasCheckbox="true"
          :searchable="true"
          :withCard="true"
          :isSelectableField="false"
          :hasDelete="false"
          trackBy="id"
          @handleSelectValue="handleCheckbox"
        >
          <template #cell(licensePlate)="data">
            <strong class="text-primary" @click="onRowClicked(data.item)">
              {{ data.item.licensePlate }}
            </strong>
          </template>
          <template #cell(idleTimeLimit)="data">
            {{ data.item.idleDuration ?? 0 }}
          </template>
          <template #cell(parkingTimeLimit)="data">
            {{ data.item.parkingDuration ?? 0 }}
          </template>
          <template #cell(imei)="data">
            {{ data.item.imei }}
          </template>
          <template #cell(fleetGroup)="data">
            {{ data.item.vgroups }}
          </template>
          <template #cell(fleetCategory)="data">
            {{ data.item.vehicleType.category }}
          </template>
          <template #cell(fleetType)="data">
            {{ data.item.vehicleType.type }}
          </template>
        </McGrapqlTable>
      </div>
    </div>

    <b-modal id="parameter-idle-parking" centered :title="$t('global.setParameter')">
      <div class="d-flex align-items-start background-info-primary p-2">
        <i class="mc-fa icon-fill_info icon-primary icon-sm" />
        <p class="m-0 px-2">
          {{ $t('setting.list.trackerSensor.idleParkingModalInfo') }}
        </p>
      </div>
      <FormulateForm v-model="form">
        <FormulateInput
          id="idleTimeLimit"
          name="idleTimeLimit"
          :placeholder="$t('setting.list.trackerSensor.idleTimeLimit')"
          suffix
          validation="min:5|max:10080|number"
          :validation-messages="{
            min: $t('setting.list.trackerSensor.validator.time'),
            max: $t('setting.list.trackerSensor.validator.time'),
          }"
          validation-behavior="live"
          error-behavior="live"
          class="my-3"
        >
          <template #label>
            <label>
              {{ $t('setting.list.trackerSensor.idleTimeLimit') }}
            </label>
          </template>
          <template #suffix>
            <div class="formulate-input-suffix">
              <span>{{ $t('global.time.minutes') }}</span>
            </div>
          </template>
        </FormulateInput>
        <FormulateInput
          id="parkingTimeLimit"
          name="parkingTimeLimit"
          :placeholder="$t('setting.list.trackerSensor.parkingTimeLimit')"
          suffix
          validation="min:5|max:10080|number"
          :validation-messages="{
            min: $t('setting.list.trackerSensor.validator.time'),
            max: $t('setting.list.trackerSensor.validator.time'),
          }"
          class="my-3"
          validation-behavior="live"
          error-behavior="live"
        >
          <template #label>
            <label>
              {{ $t('setting.list.trackerSensor.parkingTimeLimit') }}
            </label>
          </template>
          <template #suffix>
            <div class="formulate-input-suffix">
              <span>{{ $t('global.time.minutes') }}</span>
            </div>
          </template>
        </FormulateInput>
      </FormulateForm>

      <template #modal-footer="{ cancel }">
        <McButton
          size="md"
          variant="secondary"
          :text="$t('global.action.cancel')"
          @click="cancel()"
        />
        <McButton
          size="md"
          variant="primary"
          :text="$t('global.action.apply')"
          :disabled="!isValidModal"
          @click="applyParameter"
        />
      </template>
    </b-modal>
    <b-modal
      id="mc-modal-confirm"
      class="mc-modal"
      :title="$t('global.setParameter')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.setParameterConfirm') }}
          <strong>{{ idChecked.length }}</strong> {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <McButton size="md" variant="secondary" :text="$t('global.action.no')" @click="cancel()" />
        <McButton
          size="md"
          variant="primary"
          :text="$t('global.action.yes')"
          @click="submitParameter"
        />
      </template>
    </b-modal>
  </Layout>
</template>
